"use client";

import { TableHead, TableRow } from "@/shadcn-components/ui/table";
import { Button } from "@/shadcn-components/ui/button";
import { Input } from "@/shadcn-components/ui/input";
import {
  historyTh,
  HISTORY_ORDER_COL_WIDTHS,
} from "./historyDesktopTableLayout";
import type { HistorySortFilterTableHeaderProps } from "./historySortFilterHeaderTypes";
import { DENSITY } from "@/lib/density-scale";

const W = HISTORY_ORDER_COL_WIDTHS;

export function HistoryOrdersTableHeader({
  sortColumn,
  sortDirection,
  filters,
  showFilterInputs,
  onSort,
  onFilterChange,
  renderSortIcon,
  renderFilterDropdown,
}: HistorySortFilterTableHeaderProps) {
  void sortColumn;
  void sortDirection;

  const sortButton = (column: string, label: string) => (
    <Button
      variant="ghost"
      size="sm"
      className={`${DENSITY.ROW_H} gap-0 px-0.5 ${DENSITY.TEXT_WORKHORSE} font-medium`}
      onClick={() => onSort(column)}
    >
      {label}
      {renderSortIcon(column)}
    </Button>
  );

  const headerCell = (
    column: string,
    label: string,
    placeholder: string,
    widthClass: string,
    alignRight = false
  ) => (
    <TableHead
      className={`${historyTh} ${widthClass}${alignRight ? " text-right" : ""}`}
    >
      <div className={`flex items-center${alignRight ? " justify-end" : ""}`}>
        {sortButton(column, label)}
        {!showFilterInputs && renderFilterDropdown(column, placeholder)}
      </div>
    </TableHead>
  );

  const filterCell = (
    column: string,
    placeholder: string,
    widthClass: string
  ) => (
    <TableHead className={`h-7 px-1.5 py-0.5 ${widthClass}`}>
      <Input
        placeholder={placeholder}
        value={filters[column] || ""}
        onChange={(e) => onFilterChange(column, e.target.value)}
        className="h-5 px-1.5 text-[11px]"
      />
    </TableHead>
  );

  return (
    <>
      <TableRow>
        {headerCell("open", "Open", "Filter open time...", W.open)}
        <TableHead className={`${historyTh} ${W.status}`}>Status</TableHead>
        {headerCell("symbol", "Symbol", "Filter symbols...", W.symbol)}
        {headerCell("ticket", "Ticket", "Filter tickets...", W.ticket, true)}
        {headerCell("type", "Type", "Filter type...", W.type)}
        {headerCell("lots", "Lots", "Filter lots...", W.lots, true)}
        {headerCell("price", "Price", "Filter price...", W.price, true)}
        {headerCell("tp", "TP", "Filter TP...", W.tp, true)}
        {headerCell("sl", "SL", "Filter SL...", W.sl, true)}
        {headerCell("exec", "Exec", "Filter exec...", W.exec)}
        {headerCell("state", "State", "Filter state...", W.state)}
      </TableRow>

      {showFilterInputs && (
        <TableRow className="border-b bg-background">
          {filterCell("open", "Filter open time...", W.open)}
          <TableHead className={`h-7 px-1.5 py-0.5 ${W.status}`} />
          {filterCell("symbol", "Filter symbols...", W.symbol)}
          {filterCell("ticket", "Filter tickets...", W.ticket)}
          {filterCell("type", "Filter type...", W.type)}
          {filterCell("lots", "Filter lots...", W.lots)}
          {filterCell("price", "Filter price...", W.price)}
          {filterCell("tp", "Filter TP...", W.tp)}
          {filterCell("sl", "Filter SL...", W.sl)}
          {filterCell("exec", "Filter exec...", W.exec)}
          {filterCell("state", "Filter state...", W.state)}
        </TableRow>
      )}
    </>
  );
}
